export const WORKPLACE_DEEPLINK_JOIN_BASE = 'kambria-meeting://join?token=';

export const WORKPLACE_INSTALLER_URL_WIN = '';
export const WORKPLACE_INSTALLER_URL_MAC = '';

export const WORKPLACE_TERMS_URL_PLACEHOLDER = 'https://www.kambria.io/terms';
export const WORKPLACE_PRIVACY_URL_PLACEHOLDER = 'https://www.kambria.io/privacy';

/** Sau bấy nhiêu ms: nếu không blur / không ẩn tab → toast lỗi + CTA tải bộ cài */
export const MEETING_JOIN_DEEPLINK_DECISION_MS = 3000;

/** Gán URL khi có trang tải app; để rỗng = hiện chữ kiểu link, chưa điều hướng */
export const WORKPLACE_APP_DOWNLOAD_PAGE_URL = '';

/** URL file installer trong popup Kambria Meeting (EXE / DMG); để rỗng = nút tải vô hiệu tới khi gán link */
export const KAMBRIA_MEETING_APP_DOWNLOAD_URL_WIN = 'https://s3.us-west-2.amazonaws.com/staging-ced.kambria.io/desktop_application/v2/CED_Desktop_Application_Window.exe';
/** macOS Apple Silicon (M1/M2/M3…) */
export const KAMBRIA_MEETING_APP_DOWNLOAD_URL_MAC_ARM = 'https://s3.us-west-2.amazonaws.com/staging-ced.kambria.io/desktop_application/v2/CED_Desktop_Application_MacOS.dmg';
export const KAMBRIA_MEETING_APP_DOWNLOAD_URL_MAC_INTEL = 'https://s3.us-west-2.amazonaws.com/staging-ced.kambria.io/desktop_application/v2/CED_Desktop_Application_MacOs_Intel.dmg';
